import JobSearchContext from '../../../../_helper/JobSearch';
import { H6, Image, P, UL, LI } from '../../../../AbstractElements';
import React, { Fragment, useContext } from 'react';
import { Card, Col, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import i18n from '../../../../i18n';

const ListCard = ({ colClass }) => {
    const { jobData } = useContext(JobSearchContext);
    return (
        <Fragment>
            <Col className={colClass}>
                
                    <Card className={`${false ? 'ribbon-vertical-left-wrapper' : ''}`}>
                        {false ? <div className="ribbon ribbon-bookmark ribbon-vertical-left ribbon-primary"><i className="icofont icofont-globe-alt"></i></div> : ''}
                        <div className="job-search">
                            <CardBody>
                                <div className="media">
                                    <Image attrImage={{ className: 'img-40 img-fluid m-r-20', src: `${include(`../../../assets/images/${item.logo}`)}`, alt: '' }} />
                                    <div className="media-body">
                                        <H6 attrH6={{ className: 'f-w-600' }} >
                                            <Link to={`${process.env.PUBLIC_URL}/dashboard/contracts`}>{item.job_name}</Link>
                                            {false ?
                                                <span className="badge badge-primary pull-right">{i18n.t('Dashboard_Common_New')}</span>
                                                : <span className="pull-right">{i18n.t('Dashboard_Common_2DaysAgo')}</span>
                                            }
                                        </H6>
                                        <P>{i18n.t('Dashboard_ContractsReport_Area')}, {i18n.t('Dashboard_ContractsReport_City')}</P>
                                        <UL attrUL={{ className: 'rating simple-list' }} >
                                            <LI><i className="fa fa-star font-warning"></i></LI>
                                            <LI><i className="fa fa-star font-warning"></i></LI>
                                            <LI><i className="fa fa-star font-warning"></i></LI>
                                            <LI><i className="fa fa-star font-warning"></i></LI>
                                            <LI><i className="fa fa-star font-warning"></i></LI>
                                        </UL>
                                    </div>
                                </div>
                                <P>
                                    {i18n.t('Dashboard_ContractsReport_ListDescription')}
                                </P>
                            </CardBody>
                        </div>
                    </Card>
              
            </Col>
        </Fragment >
    );
};

export default ListCard;
